// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__ffmrG","file":"styles_file__1JzHY"};